<template>
    <div id="headPage">
        <el-header style="height: inherit !important;position: relative">
          <div class="main-header-box">
            <div class="main-header-right-box">
              <img src="../../../static/img/touxiangkaobei5.png" alt="">
              <img src="" alt="">
            </div>
            <div class="main-header-left-box">
              <div>{{userData.nikiName}}</div>
              <div class="names" style="margin-top: 15px;">角色：{{userData.roleList[0].roleName}}</div>
              <div class="names" v-if="userData.experience != null">经验：{{userData.experience}}</div>
              <div class="names" v-else>经验：0</div>
            </div>
          </div>
        </el-header>
    </div>
</template>

<script>
    export default {
        props:['header'],
        data(){
          return{
            userData:'',
          }
        },
        methods:{
            //获取个人信息
            getData() {
                this.$axios.get(this.URL.info).then(res => {
                    console.log(res);
                    if (res.status === 200) {
                        sessionStorage.setItem('userData', JSON.stringify(res.data))
                        this.userData = res.data
                        this.$emit('change_header',false)
                    }
                })
            },
        },

        created(){
          //获取个人信息
          this.userData = JSON.parse(sessionStorage.userData);
        },

        watch:{
            header(val){
                console.log(val);
                this.getData()
            }
        }
    }
</script>

<style lang="less" scoped>
  #headPage{
    height: 13vh;
    .main-header-box {
      display: flex;
      position: absolute;
      right: 10.3%;
      .main-header-left-box {
        margin-left: -240px;
        margin-top: 15px;
        font-size: 12px;
        .names{
          font-size: 14px;
          color:#fff;
        }
        :first-child {
          font-size: 20px;
          color: #ffffff;
          height: 30px;
          font-weight: bold;
        }
      }
      img {
        width: 100%;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/header/index.vue